import { Directive, Input, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[appFieldLength]'
})
export class FieldLengthDirective {
  @Input() appFieldLength: string = '50';

  constructor(private formControl: NgControl) { }

  @HostListener('keyup', ['$event.target'])
  onChange(inputText: HTMLInputElement) {
    const fieldValue = inputText.value;
    if (fieldValue.length > parseInt(this.appFieldLength))
      this.formControl.control?.setValue(fieldValue.substring(0, 3));
  }
}
